import React from 'react'
import ReactDOM from 'react-dom'
import { createStore, applyMiddleware, compose, combineReducers } from 'redux'
import thunk from 'redux-thunk'
import { AppContainer } from 'react-hot-loader'

import Root from './Root'
import * as reducers from './modules'


const enhancer = compose(
  applyMiddleware(thunk),
  window.__REDUX_DEVTOOLS_EXTENSION__ && FollozeState.envConfig.NODE_ENV !== 'production' ?
    window.__REDUX_DEVTOOLS_EXTENSION__() : (f) => f
)

const store = createStore(
  combineReducers({
    ...reducers,
  }),
  enhancer
)

ReactDOM.render(
  <AppContainer>
    <Root store={store}/>
  </AppContainer>,
  document.getElementById('authorization-app')
);

// Hot Module Replacement API
if (module.hot) {
  module.hot.accept('./Root', () => {
    const NewRoot = require('./Root').default
    ReactDOM.render(
      <AppContainer>
        <NewRoot store={store}/>
      </AppContainer>,
      document.getElementById('authorization-app')
    )
  })
}
